import { useCallback, useEffect, useState } from 'react'
import Link from 'next/link'
import ProductsGrid from './ProductsGrid'
import { getProducts } from '../lib/api'

export default function SimilarProducts({ product }) {
  const [products, setProducts] = useState([])

  const fetchSimilarProducts = useCallback(async () => {
    const { data: similarProducts } = await getProducts({
      $limit: 6,
      available: true,
      category: product.category._id,
      shop: product.shop,
    })

    const thisProduct = similarProducts.findIndex((prod) => prod._id === product._id)
    if (thisProduct > -1) {
      similarProducts.splice(thisProduct, 1)
    }

    setProducts(similarProducts)
  }, [product])

  useEffect(() => {
    fetchSimilarProducts()
  }, [fetchSimilarProducts])

  if (!products.length) {
    return null
  }

  return (
    <div className="my-5">
      <h6 className="h6 mb-3">Similar Products</h6>

      <ProductsGrid products={products} />

      <p className="my-5">
        <Link href={`/products?category=${product.category._id}`}>
          <a className="btn btn-outline-primary">See more like these</a>
        </Link>
      </p>
    </div>
  )
}
